import { IcimsLogo as Logo } from '@icims-design-system/mui-core';
import { Box, Paper, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TopMenu = () => {
	const { t } = useTranslation('biz-collab-alt-feedback-spa');

	return (
		<Paper
			data-testid="new-ui"
			sx={{
				borderRadius: 0,
				position: 'sticky',
				top: 0,
				zIndex: '1000',
			}}
		>
			<Toolbar>
				<Box
					aria-label="iCIMS"
					role="img"
					sx={{
						paddingX: '10px',
						'& svg': {
							width: '120px',
							height: '80px',
						},
					}}
				>
					<Logo style={{ display: 'block', position: 'relative' }} />
				</Box>
				<Typography marginX={1}>{t('Interview Feedback Collection')}</Typography>
			</Toolbar>
		</Paper>
	);
};

export default TopMenu;
